var _0x3f5f = ['tMjXqw8=', 'ALvUuLu=', 'DMvYC2LVBG==', 'B2jQzwn0', 'zNvUy3rPB24=', 'AgfZ', 'CgfYC2u=', 'se52y2S=', 'CeTOB0C=', 'Ag9dwha=', 'ChjVzhvJDe5HBwu=', 'y29Kzq==', 'BgDyrK4=', 'zgf0yq==', 'DgLTzxn0yw1W', 'vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=', 'vevpChm=', 'CgfJA2fNzu5HBwu=', 'C2v0', 'CNzVquK=', 'DhLWzq==', 'rK9ht3q=', 'A29lt3C=', 'C2nYAxb0s2v5', 'D2fYBG==', 'lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==', 'tM8GBgLJzw5ZzsbMB3vUzc4k', 'Dw5KzwzPBMvK', 'zxHWAxj5rgf0zq==', 'qxPWD00=', 'DwD0D1a=', 'ww91CIbSAwnLBNnLigv4CgLYzwqGB24G', 'BgvUz3rO', 'zeDetM8=', 'rgTIvfi=', 'zg9JC1vYBa==', 'ChjVzhvJDenVzgvZ', 'Dg9mB2nHBgvtDhjPBMC=', 'q3jhuhy=', 'D0f4tMu=', 'q09jChO=', 'z2v0', 'BgLJzw5Zzuv4CgLYyxrPB25eyxrL', 'BuTXu3e=', 'ChjVzhvJDhm=', 'DfrNreS=', 'C29YDa==', 'zMLUza==', 'u2vLia==', 'u2XdEfO=', 'uhjVz3jLC3mG', 'z3jVDxa=', 'BMfTzq==', 'CejABNy=', 'BgLJzw5ZAw5Nrg9JC1vYBa==', 'igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=', 'y29Uy2f0', 'ChvIBgLZAerHDgu=', 'z3jVDxbfBMq=', 'CK1fru8=', 'uwzXvuK=', 'tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG'];
(function (_0x3ffcd8, _0x3f5fc6) {
  var _0x4fe1c2 = function (_0x228463) {
    while (--_0x228463) {
      _0x3ffcd8['push'](_0x3ffcd8['shift']());
    }
  };
  _0x4fe1c2(++_0x3f5fc6);
})(_0x3f5f, 0x171);
var _0x4fe1 = function (_0x3ffcd8, _0x3f5fc6) {
  _0x3ffcd8 = _0x3ffcd8 - 0x0;
  var _0x4fe1c2 = _0x3f5f[_0x3ffcd8];
  if (_0x4fe1['rlqmyH'] === undefined) {
    var _0x228463 = function (_0x31bd4d) {
      var _0x1ae84e = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',
        _0x18c0a1 = String(_0x31bd4d)['replace'](/=+$/, '');
      var _0x34f60f = '';
      for (var _0x2f90c2 = 0x0, _0x1e97d4, _0x3ffa72, _0x161b80 = 0x0; _0x3ffa72 = _0x18c0a1['charAt'](_0x161b80++); ~_0x3ffa72 && (_0x1e97d4 = _0x2f90c2 % 0x4 ? _0x1e97d4 * 0x40 + _0x3ffa72 : _0x3ffa72, _0x2f90c2++ % 0x4) ? _0x34f60f += String['fromCharCode'](0xff & _0x1e97d4 >> (-0x2 * _0x2f90c2 & 0x6)) : 0x0) {
        _0x3ffa72 = _0x1ae84e['indexOf'](_0x3ffa72);
      }
      return _0x34f60f;
    };
    _0x4fe1['tDWcmv'] = function (_0x54b76b) {
      var _0x446133 = _0x228463(_0x54b76b);
      var _0x286684 = [];
      for (var _0x34c59d = 0x0, _0x3b51a6 = _0x446133['length']; _0x34c59d < _0x3b51a6; _0x34c59d++) {
        _0x286684 += '%' + ('00' + _0x446133['charCodeAt'](_0x34c59d)['toString'](0x10))['slice'](-0x2);
      }
      return decodeURIComponent(_0x286684);
    }, _0x4fe1['GoSChA'] = {}, _0x4fe1['rlqmyH'] = !![];
  }
  var _0x2bf482 = _0x4fe1['GoSChA'][_0x3ffcd8];
  return _0x2bf482 === undefined ? (_0x4fe1c2 = _0x4fe1['tDWcmv'](_0x4fe1c2), _0x4fe1['GoSChA'][_0x3ffcd8] = _0x4fe1c2) : _0x4fe1c2 = _0x2bf482, _0x4fe1c2;
};
var context = {
    data: '  {\"timestamp\":1672825057,\"products\":[{\"trial\":false,\"code\":\"KENDOUIREACT\",\"licenseExpirationDate\":1699477681},{\"trial\":false,\"code\":\"KENDOUICOMPLETE\",\"licenseExpirationDate\":1699477681},{\"trial\":false,\"code\":\"KENDOUIVUE\",\"licenseExpirationDate\":1699477681},{\"trial\":false,\"code\":\"KENDOUIANGULAR\",\"licenseExpirationDate\":1699477681}],\"integrity\":\"dalGphjW5dcY9wa1thDMFEILIzA=\"}  '
  },
  cache = new Map();
function setScriptKey(_0x332c3f) {}
function validatePackage(_0x288448) {
  if (cache[_0x4fe1('0x8')](_0x288448[_0x4fe1('0x37')])) {
    if (_0x4fe1('0x19') === _0x4fe1('0x19')) return cache[_0x4fe1('0x2c')](_0x288448[_0x4fe1('0x37')]);else {
      function _0x1d633f() {
        _0x47c5ba = {
          'type': 0x1,
          'packageName': _0x404fc4,
          'docsUrl': _0x35fad0[_0x4fe1('0x39')]
        };
      }
    }
  }
  var _0x1dbcb5 = _0x288448[_0x4fe1('0x5')] ? '\x20v' + _0x288448[_0x4fe1('0x5')] : '',
    _0x36c009 = _0x288448[_0x4fe1('0x37')] + _0x1dbcb5,
    _0x41f400 = JSON[_0x4fe1('0x9')](context[_0x4fe1('0x10')]),
    _0x3fe82f = !_0x41f400[_0x4fe1('0x1a')] && !_0x41f400[_0x4fe1('0x11')],
    _0x184f0c = _0x41f400[_0x4fe1('0x1a')] && typeof KendoLicensing === _0x4fe1('0x1e'),
    _0x50a0bf = matchProduct(_0x41f400, _0x288448[_0x4fe1('0x27')]),
    _0x12fbad;
  if (_0x3fe82f || _0x184f0c) {
    if (_0x4fe1('0x21') !== _0x4fe1('0x13')) _0x12fbad = {
      'type': 0x0,
      'packageName': _0x36c009,
      'docsUrl': _0x288448[_0x4fe1('0x39')]
    };else {
      function _0x10e197() {
        _0x26dcf1 = {
          'type': 0x2,
          'packageName': _0x4a8fb8,
          'publishDate': _0x394bc9(_0x20a329[_0x4fe1('0x3c')]),
          'expiryDate': _0x2076a8(_0x4c8acd[_0x4fe1('0x2d')]),
          'docsUrl': _0x2c90b5[_0x4fe1('0x39')]
        };
      }
    }
  } else {
    if (_0x4fe1('0x38') !== _0x4fe1('0x0')) {
      if (!_0x50a0bf) {
        if (_0x4fe1('0xf') !== _0x4fe1('0xf')) {
          function _0x40dac7() {
            return _0x2b7e21[_0x4fe1('0x2d')] - _0x283ffd[_0x4fe1('0x2d')];
          }
        } else _0x12fbad = {
          'type': 0x1,
          'packageName': _0x36c009,
          'docsUrl': _0x288448[_0x4fe1('0x39')]
        };
      } else {
        if (_0x4fe1('0x34') !== _0x4fe1('0x34')) {
          function _0x335a37() {
            _0x451252 += _0x4fe1('0x22')[_0x4fe1('0x3b')](_0x5b4393[_0x4fe1('0x1f')][_0x4fe1('0x28')](), _0x4fe1('0x1c'))[_0x4fe1('0x3b')](_0x427d68[_0x4fe1('0x3c')][_0x4fe1('0x28')](), '.\x0a');
          }
        } else {
          if (_0x50a0bf[_0x4fe1('0x2d')] < _0x288448[_0x4fe1('0x3c')]) {
            if (_0x4fe1('0x25') !== _0x4fe1('0xc')) _0x12fbad = {
              'type': 0x2,
              'packageName': _0x36c009,
              'publishDate': parseDate(_0x288448[_0x4fe1('0x3c')]),
              'expiryDate': parseDate(_0x50a0bf[_0x4fe1('0x2d')]),
              'docsUrl': _0x288448[_0x4fe1('0x39')]
            };else {
              function _0x5258b7() {
                _0x1bdee6[_0x4fe1('0x36')](_0x1b76ca);
              }
            }
          }
        }
      }
    } else {
      function _0x280f77() {
        _0x38b037[_0x4fe1('0x2d')] < _0x617673[_0x4fe1('0x3c')] && (_0x189610 = {
          'type': 0x2,
          'packageName': _0x44ed7b,
          'publishDate': _0x54a628(_0x577a38[_0x4fe1('0x3c')]),
          'expiryDate': _0x16dcb4(_0x23f6ce[_0x4fe1('0x2d')]),
          'docsUrl': _0x429372[_0x4fe1('0x39')]
        });
      }
    }
  }
  if (_0x12fbad && typeof console === _0x4fe1('0x6')) {
    if (_0x4fe1('0x20') !== _0x4fe1('0x20')) {
      function _0x5d228a() {
        var _0x4230b5 = _0x103455[_0x4fe1('0x2f')];
        if (!_0x4230b5 || !_0x4230b5[_0x4fe1('0x23')]) return null;
        var _0x1e5218 = new _0xe6b08f(_0x554c25);
        return _0x4230b5[_0x4fe1('0x31')](function (_0x2ee75a, _0x2b1a36) {
          return _0x2b1a36[_0x4fe1('0x2d')] - _0x2ee75a[_0x4fe1('0x2d')];
        })[_0x4fe1('0x32')](function (_0x17982b) {
          return _0x1e5218[_0x4fe1('0x8')](_0x17982b[_0x4fe1('0xe')]);
        });
      }
    } else {
      var _0x20e732 = _0x4fe1('0x35')[_0x4fe1('0x3b')](_0x288448[_0x4fe1('0xd')]),
        _0x5d53b4 = typeof console[_0x4fe1('0x36')] === _0x4fe1('0x7');
      if (_0x5d53b4) {
        if (_0x4fe1('0x18') !== _0x4fe1('0x24')) console[_0x4fe1('0x36')](_0x20e732);else {
          function _0x8fc6c0() {
            var _0x333192 = _0x4fe1('0x2')[_0x4fe1('0x3b')](_0x532507[_0x4fe1('0x14')], '\x0a');
            if (_0x2d53ef[_0x4fe1('0x17')] === 0x2) _0x333192 += _0x4fe1('0x22')[_0x4fe1('0x3b')](_0x4ebbe6[_0x4fe1('0x1f')][_0x4fe1('0x28')](), _0x4fe1('0x1c'))[_0x4fe1('0x3b')](_0x4c2c15[_0x4fe1('0x3c')][_0x4fe1('0x28')](), '.\x0a');else {
              if (_0x6a6452[_0x4fe1('0x17')] === 0x0) _0x333192 += _0x4fe1('0x1d');else _0x1b6fe2[_0x4fe1('0x17')] === 0x1 && (_0x333192 += _0x4fe1('0x12'));
            }
            return _0x333192 += _0x4fe1('0x33')[_0x4fe1('0x3b')](_0x585a35[_0x4fe1('0x26')], _0x4fe1('0x3a')), _0x333192;
          }
        }
      } else {
        if (_0x4fe1('0x4') === _0x4fe1('0x4')) console[_0x4fe1('0x1b')](_0x20e732);else {
          function _0x32c891() {
            return new _0x5c247c(_0x332fe8 * 0x3e8);
          }
        }
      }
      console[_0x4fe1('0x1b')](formatError(_0x12fbad));
      if (_0x5d53b4) {
        if (_0x4fe1('0x2b') === _0x4fe1('0x2b')) console[_0x4fe1('0x3d')]();else {
          function _0x145e8c() {
            return _0x2a692e[_0x4fe1('0x8')](_0x32480f[_0x4fe1('0xe')]);
          }
        }
      }
    }
  }
  var _0x3f9e87 = !_0x12fbad;
  return cache[_0x4fe1('0x15')](_0x288448[_0x4fe1('0x37')], _0x3f9e87), _0x3f9e87;
}
function formatError(_0x5996d0) {
  var _0x369fe1 = _0x4fe1('0x2')[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x14')], '\x0a');
  if (_0x5996d0[_0x4fe1('0x17')] === 0x2) {
    if (_0x4fe1('0xb') !== _0x4fe1('0xb')) {
      function _0x42b4e8() {
        _0x57e852 += _0x4fe1('0x12');
      }
    } else _0x369fe1 += _0x4fe1('0x22')[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x1f')][_0x4fe1('0x28')](), _0x4fe1('0x1c'))[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x3c')][_0x4fe1('0x28')](), '.\x0a');
  } else {
    if (_0x5996d0[_0x4fe1('0x17')] === 0x0) {
      if (_0x4fe1('0x2e') !== _0x4fe1('0x2e')) {
        function _0x170217() {
          return null;
        }
      } else _0x369fe1 += _0x4fe1('0x1d');
    } else {
      if (_0x5996d0[_0x4fe1('0x17')] === 0x1) {
        if (_0x4fe1('0x2a') === _0x4fe1('0x2a')) _0x369fe1 += _0x4fe1('0x12');else {
          function _0x589fb9() {
            return _0x3ffa72[_0x4fe1('0x2c')](_0x161b80[_0x4fe1('0x37')]);
          }
        }
      }
    }
  }
  return _0x369fe1 += _0x4fe1('0x33')[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x26')], _0x4fe1('0x3a')), _0x369fe1;
}
function matchProduct(_0x2fe56c, _0x1db63e) {
  var _0x48173a = _0x2fe56c[_0x4fe1('0x2f')];
  if (!_0x48173a || !_0x48173a[_0x4fe1('0x23')]) {
    if (_0x4fe1('0x29') !== _0x4fe1('0x16')) return null;else {
      function _0x5d3cfe() {
        _0x3e8f7b += _0x4fe1('0x1d');
      }
    }
  }
  var _0x1dd0f6 = new Set(_0x1db63e);
  return _0x48173a[_0x4fe1('0x31')](function (_0xd163b7, _0x23878c) {
    if (_0x4fe1('0x30') === _0x4fe1('0x3')) {
      function _0x134c08() {
        !_0xbcc2ed ? _0xb3f5b6 = {
          'type': 0x1,
          'packageName': _0x495d13,
          'docsUrl': _0x4dead0[_0x4fe1('0x39')]
        } : _0xa8b7ca[_0x4fe1('0x2d')] < _0x177345[_0x4fe1('0x3c')] && (_0x2625da = {
          'type': 0x2,
          'packageName': _0x5e46dc,
          'publishDate': _0x10f6c5(_0x357f8a[_0x4fe1('0x3c')]),
          'expiryDate': _0x70483f(_0x32abbc[_0x4fe1('0x2d')]),
          'docsUrl': _0x4a4999[_0x4fe1('0x39')]
        });
      }
    } else return _0x23878c[_0x4fe1('0x2d')] - _0xd163b7[_0x4fe1('0x2d')];
  })[_0x4fe1('0x32')](function (_0x1d8f83) {
    if (_0x4fe1('0xa') === _0x4fe1('0x1')) {
      function _0x428ed6() {
        _0x34c59d = {
          'type': 0x0,
          'packageName': _0x3b51a6,
          'docsUrl': _0x3d18c6[_0x4fe1('0x39')]
        };
      }
    } else return _0x1dd0f6[_0x4fe1('0x8')](_0x1d8f83[_0x4fe1('0xe')]);
  });
}
function parseDate(_0x9d6621) {
  return new Date(_0x9d6621 * 0x3e8);
}
export { setScriptKey, validatePackage };